// Locale-aware string comparator (pt-BR, case/accent-insensitive) for alphabetical sorting.
export const compareStrings = (a, b) => {
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a.localeCompare(b, "pt-BR", { sensitivity: "base" });
};
